import { render, staticRenderFns } from "./LibramientoTermgModals.vue?vue&type=template&id=51bcdfc6&scoped=true&"
import script from "./LibramientoTermgModals.vue?vue&type=script&lang=js&"
export * from "./LibramientoTermgModals.vue?vue&type=script&lang=js&"
import style0 from "./LibramientoTermgModals.vue?vue&type=style&index=0&id=51bcdfc6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bcdfc6",
  null
  
)

/* custom blocks */
import block0 from "./LibramientoTermgModals.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
